import React from 'react'
import { Modal, Box, Typography, Button } from '@mui/material'

interface MaterialeItem {
  id: number
  codice: string
  nomeFile: string
  tempoStudio: string
  associazioneCorso: string
  domandeAssociate: number
}

interface MaterialViewerModalProps {
  isOpen: boolean
  onClose: () => void
  material: MaterialeItem | null
}

const MaterialViewerModal: React.FC<MaterialViewerModalProps> = ({ isOpen, onClose, material }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="material-viewer-modal-title"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '95%', sm: '80%', md: '70%' },
          height: { xs: '95vh', sm: '90vh' },
          bgcolor: 'background.paper',
          borderRadius: 0,
          boxShadow: 24,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header */}
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'divider', backgroundColor: '#F8F9F9' }}>
          <div className="flex items-center justify-between">
            <Typography variant="h6" component="h2" sx={{ color: '#4F4F4F', fontWeight: 'bold' }}>
              {material?.nomeFile}
            </Typography>
            <Button
              onClick={onClose}
              sx={{ minWidth: 'auto', p: 1 }}
            >
              <i className="ri-close-line text-xl"></i>
            </Button>
          </div>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, p: 3, overflow: 'auto' }}>
          {material && (
            <div className="h-full flex items-center justify-center ">
              {/* Mock content based on material type */}
              <div className="bg-gray-100 rounded-lg p-8 text-center h-full  flex flex-col items-center justify-center">
                <i className="ri-file-text-line text-6xl text-gray-400 mb-4"></i>
                <h3 className="text-lg font-semibold text-gray-700 mb-2">
                  {material.nomeFile}
                </h3>
                <p className="text-gray-600 mb-4">
                  Codice: {material.codice}
                </p>
                <p className="text-gray-600 mb-4">
                  Tempo di studio: {material.tempoStudio}
                </p>
                <p className="text-gray-600 mb-4">
                  Domande associate: {material.domandeAssociate}
                </p>
                <div className="bg-blue-100 border border-blue-300 rounded-lg p-4">
                  <p className="text-blue-800 text-sm">
                    <i className="ri-information-line mr-2"></i>
                    Questo è un contenuto di esempio. In una implementazione reale, qui verrebbe mostrato il contenuto effettivo del materiale (PDF, video, SCORM, ecc.)
                  </p>
                </div>
              </div>
            </div>
          )}
        </Box>
      </Box>
    </Modal>
  )
}

export default MaterialViewerModal
